import MenuCategoryHeader from './MenuCategoryHeader';
import connectContainer from './MenuCategoryHeaderContainer';

export default connectContainer(MenuCategoryHeader);
